import { createStyles, makeUiStyles, Theme } from '../../../../styles/styles';
import { isMobileApp } from '../../../../mobile-app/mobileAppHandlers';
import { zIndex } from '../../../../theme/constants';
import { StylesIndexInjections } from 'common-react';

const mobileBottomPadding = 32;
const mobileTopPadding = 16;
const getMobileBottomPadding = (theme: Theme) => mobileBottomPadding + theme.space.mobileBottomPadding();
const getMobileTopPadding = (theme: Theme) => mobileTopPadding + theme.space.mobileTopPadding();

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    maxWidth: '100%',
    backgroundColor: theme.color.greys[0],
    border: 'none',
    margin: 0,
    zIndex: zIndex.modalZIndex,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: isMobileApp() ? getMobileTopPadding(theme) : mobileTopPadding,
    paddingBottom: isMobileApp() ? getMobileBottomPadding(theme) : mobileBottomPadding,
    display: 'flex',
    flexDirection: 'column',
    '& .MuiAutocomplete-popper': {
      position: 'relative',
      height: `calc(100% - 140px)`,
    }
  },
  closeButton: {
    position: 'absolute',
    top: 4,
    right: 0,
    border: 'none',
    backgroundColor: 'transparent',
    minWidth: 24,
    minHeight: 24,
    '& svg': {
      verticalAlign: 'top',
      width: 16,
      height: 16,
      color: theme.color.greys[80]
    },
  },
  content: {
    flex: '1 1 auto',
    minHeight: 0,
    height: '100%',
  },
  modalFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    alignItems: 'center',
    marginTop: 'auto',
    paddingTop: 32,
  },
  header: {
    display: 'flex',
    gap: 16,
    position: 'relative',
    minHeight: 32,
  }
}), { name: 'AutocompleteModal', index: StylesIndexInjections.UI_MOLECULES });
